import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Phase } from '../../../projects/domain/phase';
import { PhaseWithEmployees } from "../../../projects/domain/phase-with-employees";

@Component({
  selector: 'app-phase-radio-button',

  standalone: false,
  template: `
    <div class="fx fx--col fx__gap--8 fx-fill py-8 w-100">
      <div class="fx fx__just--space-between fx__align--center">
        <span class="text--light-gray text-12-500">PHASE {{ index + 1 }}</span>
        <span class="text--light-gray text-12-500 nowrap">{{ phase?.startDate }} - {{ phase?.endDate }}</span>
      </div>

      <div class="fx fx__just--space-between fx__align--center">
        <span class="text--gray text-20-500 pt-4">{{ phase?.phaseName }}</span>
        <span class="text--gray text-20-500 pt-4">{{ phaseWithEmployees.assigned }}/{{ phaseWithEmployees.required }}</span>
      </div>

      <div class="gd gd__row-gap--8 professions-grid">
        <span *ngFor="let profession of phaseWithEmployees?.professionCounters"
              class="fx profession-item text--light-gray text-14-500">
          <ng-container *ngIf="profession.professionName !== 'Other'">
            {{ profession.professionName }} {{ profession.assigned }}/{{ profession.required }}
          </ng-container>
        </span>
      </div>
    </div>
  `,
  styles: [`
    .professions-grid {
      grid-template-columns: repeat(3, 1fr);
    }
    .profession-item {
      align-items: center;
      justify-content: flex-start;
    }
    .profession-item:nth-child(3n+2) {
      justify-content: center;
    }
    .profession-item:nth-child(3n) {
      justify-content: flex-end;
    }
`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhaseRadioButtonComponent {
  @Input() phase: Phase;
  @Input() phaseWithEmployees: PhaseWithEmployees;
  @Input() index: number;
}
